import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { DelinquentClaimsReportDetails } from '@/modules/Reports';

const DelinquentClaimsReportPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.DELINQUENT_CLAIMS_REPORT,
      title: 'Delinquent Claims',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }

  return (
    <Box width="100%" data-testid="delinquent-claims-report-page">
      <div>
        <Topbar />
      </div>
      <Box>
        <Box margin={{ top: 'spacing24' }}>
          <DelinquentClaimsReportDetails />
        </Box>
      </Box>
    </Box>
  );
};

export default DelinquentClaimsReportPage;
